export default "__VITE_ASSET__HkPp_3ya__"